import { IHousingObjectResponse } from '@/types';
import { FilterSchema } from '@/types/structuredData';

export const generateFiltersSchema = (data: IHousingObjectResponse): FilterSchema => {
  const filters: Array<{ '@type': 'ListItem'; name: string; value?: string | number | string[] }> =
    [];

  if (data.categoryTitle) {
    filters.push({
      '@type': 'ListItem',
      name: 'Object Type',
      value: data.categoryTitle,
    });
  }

  if (data.sell) {
    filters.push({
      '@type': 'ListItem',
      name: 'Offer Type',
      value: 'Sell',
    });
  }
  if (data.rent) {
    filters.push({
      '@type': 'ListItem',
      name: 'Offer Type',
      value: 'Rent',
    });
  }

  if (data.countryTitle) {
    filters.push({
      '@type': 'ListItem',
      name: 'Country',
      value: data.countryTitle,
    });
  }
  if (data.divisionTitle) {
    filters.push({
      '@type': 'ListItem',
      name: 'Division',
      value: data.divisionTitle,
    });
  }
  if (data.districtTitle) {
    filters.push({
      '@type': 'ListItem',
      name: 'District',
      value: data.districtTitle,
    });
  }
  if (data.place) {
    filters.push({
      '@type': 'ListItem',
      name: 'Place',
      value: data.place,
    });
  }

  if (
    data.prices?.sellPrice &&
    data.prices.sellPrice !== 'Preis auf Anfrage' &&
    data.prices.sellPrice !== 'Auf Anfrage'
  ) {
    const numericPrice = data.prices?.sellPriceNumeric;
    if (numericPrice !== null && numericPrice !== undefined) {
      filters.push({
        '@type': 'ListItem',
        name: 'Price',
        value: numericPrice,
      });
    }
  }
  if (
    data.prices?.grossRent &&
    data.prices.grossRent !== 'Preis auf Anfrage' &&
    data.prices.grossRent !== 'Auf Anfrage'
  ) {
    const numericPrice = data.prices?.grossRentNumeric;
    if (numericPrice !== null && numericPrice !== undefined) {
      filters.push({
        '@type': 'ListItem',
        name: 'Rent Price',
        value: numericPrice,
      });
    }
  }

  if (data.squares?.areaDetailed) {
    filters.push({
      '@type': 'ListItem',
      name: 'Area',
      value: data.squares.areaDetailed,
    });
  }
  if (data.squares?.livingArea) {
    filters.push({
      '@type': 'ListItem',
      name: 'Living Area',
      value: data.squares.livingArea,
    });
  }
  if (data.squares?.groundArea) {
    filters.push({
      '@type': 'ListItem',
      name: 'Ground Area',
      value: data.squares.groundArea,
    });
  }

  if (data.otherDetails?.roomNumber) {
    filters.push({
      '@type': 'ListItem',
      name: 'Rooms',
      value: data.otherDetails.roomNumber,
    });
  }

  if (data.equipmentGroups && Array.isArray(data.equipmentGroups)) {
    data.equipmentGroups.forEach((group) => {
      if (group.items && Array.isArray(group.items)) {
        const equipmentNames = group.items.map((item) => item.title).filter(Boolean);
        if (equipmentNames.length > 0) {
          filters.push({
            '@type': 'ListItem',
            name: group.title || 'Amenities',
            value: equipmentNames,
          });
        }
      }
    });
  }

  if (data.customEquips && Array.isArray(data.customEquips) && data.customEquips.length > 0) {
    const customEquipNames = data.customEquips.map((equip) => equip.title).filter(Boolean);
    if (customEquipNames.length > 0) {
      filters.push({
        '@type': 'ListItem',
        name: 'Custom Equipment',
        value: customEquipNames,
      });
    }
  }

  if (data.otherDetails?.heating) {
    filters.push({
      '@type': 'ListItem',
      name: 'Heating',
      value: data.otherDetails.heating,
    });
  }
  if (data.otherDetails?.state) {
    filters.push({
      '@type': 'ListItem',
      name: 'State',
      value: data.otherDetails.state,
    });
  }
  if (data.otherDetails?.furniture) {
    filters.push({
      '@type': 'ListItem',
      name: 'Furniture',
      value: data.otherDetails.furniture,
    });
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: filters.length > 0 ? filters : undefined,
  };
};
